import { defineMessages, IntlShape } from "react-intl";

enum ResourceContentType {
  DOCUMENT = "document",
  SPREADSHEET = "spreadsheet",
  PRESENTATION = "presentation",
  IMAGE = "image",
  PDF = "pdf",
  VIDEO = "video",
  ARCHIVE = "archive",
  AUDIO = "audio",
  LINK = "link",
}

const messages = defineMessages<ResourceContentType>({
  [ResourceContentType.ARCHIVE]: {
    id: "resources.content.type.archive",
    defaultMessage: "Archives (zip)",
    description: "Archives (zip) resource type",
  },
  [ResourceContentType.AUDIO]: {
    id: "resources.content.type.audio",
    defaultMessage: "Audio",
    description: "Audio resource type",
  },
  [ResourceContentType.DOCUMENT]: {
    id: "resources.content.type.document",
    defaultMessage: "Documents",
    description: "Documents resource type",
  },
  [ResourceContentType.IMAGE]: {
    id: "resources.content.type.image",
    defaultMessage: "Photos & Images",
    description: "Photos resource type",
  },
  [ResourceContentType.LINK]: {
    id: "resources.content.type.link",
    defaultMessage: "Links / URLs",
    description: "Links resource type",
  },
  [ResourceContentType.PDF]: {
    id: "resources.content.type.pdf",
    defaultMessage: "PDFs",
    description: "PDFs resource type",
  },
  [ResourceContentType.PRESENTATION]: {
    id: "resources.content.type.presentation",
    defaultMessage: "Presentations",
    description: "Presentations resource type",
  },
  [ResourceContentType.SPREADSHEET]: {
    id: "resources.content.type.spreadsheet",
    defaultMessage: "Spreadsheets",
    description: "Spreadsheets resource type",
  },
  [ResourceContentType.VIDEO]: {
    id: "resources.content.type.video",
    defaultMessage: "Videos",
    description: "Videos resource type",
  },
});

export const getResourceContentTypeName = (intl: IntlShape, type: ResourceContentType) =>
  intl.formatMessage(messages[type]);

export default ResourceContentType;
